import React from 'react'
import ContactUs from '../components/ContactUs'
import ContactForm from '../components/ContactForm'
import ContactMap from '../components/ContactMap'

const ContactPage = () => {
  return (
    <>
        <ContactUs />
        <ContactForm />
        <ContactMap />
    </>
  )
}

export default ContactPage
